import React, { useContext, useState } from 'react';
import Modal from './Modal';
import Button from '../ui/Button';
import { getAxiosTokenInstance } from '../../../utils/axiosInstance';
import { message } from 'antd';
import { NecttosContext } from '../../../context/NecttosContext';

interface ProgramOutcomeModalProps {
  isOpen: boolean;
  onClose: () => void;
  subjectId: string;
}

const ProgramOutcomeModal: React.FC<ProgramOutcomeModalProps> = ({ isOpen, onClose, subjectId}) => {
  const { collegeId } = useContext(NecttosContext);
  const [relatedInput, setRelatedInput] = useState('');


  const [formData, setFormData] = useState({
  type: 'PO',
  code: '',
  title: '',
  description: '',
  achievement: '',
  relatedCourses: [] as string[],
  collegeId,
});

const handleAddCourse = () => {
  const trimmed = relatedInput.trim();
  if (trimmed && !formData.relatedCourses.includes(trimmed)) {
    setFormData((prev) => ({
      ...prev,
      relatedCourses: [...prev.relatedCourses, trimmed],
    }));
    setRelatedInput('');
  }
};

const handleRemoveCourse = (index: number) => {
  setFormData((prev) => ({
    ...prev,
    relatedCourses: prev.relatedCourses.filter((_, i) => i !== index),
  }));
};


  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateForm = (): boolean => {
    const newErrors: { [key: string]: string } = {};
    if (!formData.code.trim()) newErrors.code = 'Outcome code is required';
    if (!formData.title.trim()) newErrors.title = 'Outcome title is required';
    if (!formData.description.trim()) newErrors.description = 'Description is required';
    if (!formData.achievement.trim()) newErrors.achievement = 'Achievement is required';
    // if (!formData.relatedCourses.trim()) newErrors.relatedCourses = 'At least one related course is required';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
        setIsSubmitting(true);
      const instance = await getAxiosTokenInstance();
      const resp = await instance.post('/college/lms/poco/create', {...formData, subjectId, collegeId});
      
      if( resp.data.success) {
        message.success(resp.data.message)
        console.log(resp.data.message)
      }
      setIsSubmitting(false);
    } catch (error) {
      console.error('Error submitting outcome:', error);
      message.error('Failed to add Program Outcome');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Add Program Outcome" size="lg">
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Code */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Outcome Code *</label>
          <input
            type="text"
            value={formData.code}
            onChange={(e) => setFormData({ ...formData, code: e.target.value })}
            className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
              errors.code ? 'border-red-500' : 'border-gray-300'
            }`}
            placeholder="e.g., PO1"
          />
          {errors.code && <p className="mt-1 text-sm text-red-600">{errors.code}</p>}
        </div>

        {/* Title */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Title *</label>
          <input
            type="text"
            value={formData.title}
            onChange={(e) => setFormData({ ...formData, title: e.target.value })}
            className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
              errors.title ? 'border-red-500' : 'border-gray-300'
            }`}
            placeholder="e.g., Critical Thinking and Problem Solving"
          />
          {errors.title && <p className="mt-1 text-sm text-red-600">{errors.title}</p>}
        </div>

        {/* Description */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Description *</label>
          <textarea
            value={formData.description}
            onChange={(e) => setFormData({ ...formData, description: e.target.value })}
            className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
              errors.description ? 'border-red-500' : 'border-gray-300'
            }`}
            placeholder="Describe the expected outcome for students..."
            rows={4}
          />
          {errors.description && <p className="mt-1 text-sm text-red-600">{errors.description}</p>}
        </div>

        {/* Achievement */}
<div>
  <label className="block text-sm font-medium text-gray-700 mb-2">Achievement Level *</label>
  <select
    value={formData.achievement}
    onChange={(e) => setFormData({ ...formData, achievement: e.target.value })}
    className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
      errors.achievement ? 'border-red-500' : 'border-gray-300'
    }`}
  >
    <option value="">Select level</option>
    <option value="High">High</option>
    <option value="Medium">Medium</option>
    <option value="Low">Low</option>
  </select>
  {errors.achievement && <p className="mt-1 text-sm text-red-600">{errors.achievement}</p>}
</div>


        {/* CO || PO */}
        <div>
  <label className="block text-sm font-medium text-gray-700 mb-2">Outcome Type *</label>
  <select
    value={formData.type}
    onChange={(e) => setFormData((prev) => ({ ...prev, type: e.target.value }))}
    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
  >
    <option value="PO">Program Outcome (PO)</option>
    <option value="CO">Course Outcome (CO)</option>
  </select>
</div>

        {/* Related Courses */}
<div>
  <label className="block text-sm font-medium text-gray-700 mb-2">Related Courses *</label>
  
  <div className="flex space-x-2 mb-2">
    <input
      type="text"
      value={relatedInput}
      onChange={(e) => setRelatedInput(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleAddCourse();
        }
      }}
      className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      placeholder="Enter course and press Enter"
    />
    <button
      type="button"
      onClick={handleAddCourse}
      className="px-3 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded-md"
    >
      Add
    </button>
  </div>

  {/* Display list of related courses */}
  <div className="flex flex-wrap gap-2">
    {formData.relatedCourses.map((course, index) => (
      <span
        key={index}
        className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-sm flex items-center space-x-2"
      >
        {course}
        <button
          type="button"
          onClick={() => handleRemoveCourse(index)}
          className="ml-1 text-red-500 hover:text-red-700 text-xs"
        >
          ×
        </button>
      </span>
    ))}
  </div>

  {errors.relatedCourses && <p className="mt-1 text-sm text-red-600">{errors.relatedCourses}</p>}
</div>


        {/* Footer */}
        <div className="flex justify-end space-x-4 pt-4 border-t border-gray-200">
          <Button variant="secondary" onClick={onClose}>Cancel</Button>
          <Button type="submit" disabled={isSubmitting}>
            {isSubmitting ? (
              <span className="flex items-center">
                <div className="animate-spin w-4 h-4 border-2 border-white border-t-transparent rounded-full mr-2"></div>
                Saving...
              </span>
            ) : (
              'Save Outcome'
            )}
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default ProgramOutcomeModal;
